<!--
 * @Author: 王金飞
 * @Date: 2021-11-24 14:57:54
 * @LastEditTime: 2021-11-30 12:08:40
 * @LastEditors: Please set LastEditors
 * @Description: 个人记账页面
 * @FilePath: \team-web\src\views\IndividualRecord\IndividualRecord.vue
-->
<template>
  <div class="page">
    <div class="button">
      <div class="totalmonth">
          <span class="total"> 当月统计</span>
          <span class="totaltime">{{ year + "-" + month }}</span>
      </div>
       <div>
          <span class="totalmoney">总收入：</span>
          <span class="totalincome">+{{totalincome.toFixed(2)}}</span>
       </div>
       <div class="line"></div>
        <div class="line-right">
          <span class="totalmoney">总支出：</span>
          <span class="totalexpenses">-{{totalexpenses.toFixed(2)}}</span>
        </div>
      <AddIncomeExpenses :billType='index+1' ref="editincome" @close='getBillDetail()' :class="[index+1==1?'recoderincome':'recoderexpenses']"  v-for="(item,index) in 2" :key='index'></AddIncomeExpenses>
    </div>
    <div class="individualrecord">
      <div class="aside">
        <div @click="isshow = !isshow" class="yearselect">
          <span>{{ year }}年</span>
          <span class="expand"><img src="@/assets/record/expand.png" alt=""></span>
        </div>
        <template v-if="isshow">
          <div class="yearoption">
            <div
              v-for="(item, index) in yearoption"
              :key="index"
              class="itemyear"
              @click="changeyear(item)"
            >
              {{ item + "年" }}
            </div>
          </div>
        </template>
        <div
          v-for="(item, index) in 12"
          :key="index"
          :class="[
            { month: true },
            month == index + 1 ? 'selectedmonth' : 'month'
          ]"
          @click="changemonth(index)"
        >
          <span>{{item}}</span>
          <span class="monthunit">{{`&nbsp;`}}月</span>
        </div>
      </div>
      <div class="content">
          <div class="content-nav">
              <div class="nav-time">时间</div>
              <div class="nav-income">收入</div>
              <div class="nav-income mar-20">支出</div>
              <div class="nav-note">备注</div>
              <div>操作</div>
          </div>
        <div class="list-item" v-if="list.length>0">
                <div v-for="(item, index) in list" :key="index">
                    <div class="item-title">
                         <div class="title-date">
                             <span class="day">{{item.recordDate |getdate}}</span>
                             <span class="title-time">{{`&nbsp;`}}/{{`&nbsp;`}}</span>
                              <span class="title-time">{{item.recordDate |getmonth }}</span>
                              <span class="title-time">{{`&nbsp;`}}/{{`&nbsp;`}}</span>
                              <span class="title-time">{{item.recordDate |getyear }}</span>
                          </div>
                         <div class="title-income">{{'+'+item.income.toFixed(2)}}</div>
                         <div class="title-expenses">{{'-'+item.expenses.toFixed(2)}}</div>
                    </div>
                    <div v-for="seconde in item.settleBillVoList" :key='seconde.no' class="item-content">
                        <div class="item-img"><img :src="getimg(seconde.billCostName)" alt=""></div>
                        <div class="item-name">{{ seconde.billCostName}}</div>
                        <div class="item-type" v-if="seconde.billType==1">收</div>
                        <div class="item-typezhi" v-if="seconde.billType==2">支</div>
                        <div class="item-Amount">{{seconde.billAmount.toFixed(2)}}</div>
                        <div class="item-remark">{{seconde.remark || '/'}}</div>
                        <div class="item-icon mar-20" @click="edit(seconde.no,seconde.billType)"><img src="@/assets/record/edit.png" alt=""></div>
                        <div class="item-icon" @click="del(seconde.no)"><img src="@/assets/record/delete.png" alt=""></div>
                    </div>
                </div>
        </div>
        <BaseEmptyData v-if="list.length==0"></BaseEmptyData>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "@/api/apiIndividualRecord"
export default {
  name: "individualrecord",
  components: {
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
    AddIncomeExpenses: () => import("./components/AddIncomeExpenses")
  },
  data() {
    return {
      year: "",
      yearoption: [],
      isshow: false,
      month: "",
      list: [],
      expenses: "", //总支出
      income: "" ,//总收入
    }
  },
  methods: {
    getyeardata() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth()+1
      this.month = `0${month}`.substr(-2)
      let arr=[];
      let i=year;
      while (i>=1970){
        arr.push(i--)
      }
      this.year = year;
      this.yearoption = arr;
    },
    changemonth(index) {
      this.month = `0${++index}`.substr(-2)
      this.getBillDetail()
    },
    changeyear(val) {
      this.year = val;
      this.isshow = false;
      this.getBillDetail()
    },
    async getBillDetail() {
      let params ={};
      params.monthDate = this.year +'-' +this.month;
      params.type = '1'
      let { data } = await api.getsettleBilllist(params)
      if (data.code == 200) {
        this.list = data.data
      }
    },
    edit(no,type){
      // 编辑收入/支出
      this.$refs.editincome[type-1].open(no)
    },
    // 删除个人记账记录
    async del(no){
         this.$message.tips('确定删除该条记账信息？',async v=>{
                  if(v){
                    let {data}= await api.deleteBill(no);
                    if(data.code==200){
                        this.getBillDetail()
                    }
                  }
        })
    },
    getimg(type){
       switch(type){
         case '补贴':  return require('@/assets/record/butie.png');
         case '工程款':  return require('@/assets/record/gongchengkuan.png');
         case '奖金':  return require('@/assets/record/jiangjin.png');
         case '工资':  return require('@/assets/record/gongzi.png');
         case '其他':  return require('@/assets/record/qita.png');
         case '材料费':  return require('@/assets/record/cailiao.png');
         case '工资发放':  return require('@/assets/record/gongzifafang.png');
         case '生活用品':  return require('@/assets/record/shenghuo.png');
         case '交通':  return require('@/assets/record/jiaotong.png');
         case '医疗':  return require('@/assets/record/yiliao.png');
         case '吃饭':  return require('@/assets/record/chifan.png');
         case '娱乐':  return require('@/assets/record/yule.png');
         case '住宿':  return require('@/assets/record/zhusu.png');
       }
    }
  },
  computed:{
    // 总收入合计
    totalincome(){
      let money = null;
      if(this.list.length>0){
        this.list.forEach(item => {
          money += item.income
        });
        return money  
      }
      else{
        return 0
      }
    },
    //总支出合计
    totalexpenses(){
      let money = null;
      if(this.list.length>0){
        this.list.forEach(item => {
          money += item.expenses
        });
        return money  
      }
      else{
        return 0
      }
    },
  },
  filters:{
      getdate(val){
          if(val){
              return val.split("-")[2]
          }
      },
      getmonth(val){
          if(val){
              return val.split("-")[1]
          }
      },
      getyear(val){
          if(val){
              return val.split("-")[0]
          }
      },
  },
  created() {
    this.getyeardata()
    this.getBillDetail()
  }
}
</script>

<style lang="scss" scoped>
.page {
  box-sizing: border-box;
  margin: 10px auto;
  padding: 20px;
  width: 1200px;
  background: #fff;
  font-family: MicrosoftYaHei;
  .button{
      display: flex;
      height: 34px;
      align-items: center;
      margin-bottom: 20px;
      .totalmonth{
          // width: 230px;
          color: #333333;
          font-weight: bold;
          margin-right: 30px;
          .total{
              font-size: 18px; 
              margin-right: 5px;  
          }
          .totaltime{
              font-size: 14px;
          }
      }
      .line-right{
        flex: 1;
      }
      .totalmoney{
          font-size: 14px;
          color: #333333;
      }
      .totalincome{
          color: #E1251B;
          font-size: 16px;
      }
      .totalexpenses{
          color: #55B148;
          font-size: 16px;
          display: inline-block;
          margin-right: 350px;
      }
      .line{
          width: 1px;
          height: 14px;
          background: #C0C4CC;
          margin:0 10px 0 10px;
      }
    .recoderincome{
        margin-right: 8px;
        /deep/ .el-button{
           border: 1px solid #B79255;
           color: #B79255 !important; 
           width: 72px;
           height: 34px;
           padding: 0;
           border-radius: unset;
        }
    }
    .recoderexpenses{
         /deep/ .el-button{
           color: #FFFFFF !important; 
           width: 72px;
           height: 34px;
           border:unset;
           padding: 0;
           background: #B79255;
           border-radius: unset;
        }
    }
  }
  .individualrecord {
    display: flex;
    .aside {
      width: 152px;
      position: relative;
      margin-right: 10px;
      border-bottom:1px solid #E6E8EE;
      .yearselect {
        cursor: pointer;
        height: 44px;
        line-height: 44px;
        padding-left: 15px;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        border:1px solid #E6E8EE;
        span{
          display: inline-block; 
        }
        .expand{
            margin-left: 61px;
            img{
              width: 10px;
              height: 6px;
            }
          }
      }
      .yearoption {
        position: absolute;
        top: 46px;
        left: 0px;
        width: 100%;
        box-sizing: border-box;
        font-size: 14px;
        height: 270px;
        overflow-y: scroll;
        .itemyear {
          padding-left: 15px;
          height: 44px;
          border: 1px solid #E6E8EE;
          color: #333333;
          background-color: #FAFAFA;
          line-height: 44px;
          border-top: unset;
          cursor: pointer;
        }
      }
      .month {
        height: 42px;
        line-height: 42px;
        background-color: #ffff;
        padding-left: 20px;
        font-size: 20px;
        border-right:1px solid #E6E8EE;
        color: #C0C4CC;
        cursor: pointer;
      }
      .monthunit{
        font-size: 12px;
      }
      .month:hover {
        background-color: rgba(183, 146, 85, 0.1);
      }
      .selectedmonth {
        height: 42px;
        line-height: 42px;
        padding-left: 20px;
        color: #B79255;
        font-weight: bold;
        font-size: 20px;
        border-left: 4px solid #B79255;
        border-right: unset;
        border-top: 1px solid #E6E8EE;
        border-bottom: 1px solid #E6E8EE;
        box-sizing: border-box;
      }
    }
    .content {
      flex: 1;
      .content-nav {
        display: flex;
        align-items: center;
        height: 44px;
        background: #F5F7FA;
        color: #666666;
        font-size: 14px;
        .nav-time{
            margin-left: 20px;
            width: 208px;
        }
        .nav-income{
             width: 208px;
        }
        .nav-note{
            width: 260px;
        }
        .mar-20{
          margin-left: 20px;
        }
      }
      .list-item {
        height: 508px;
        overflow-y: scroll;
        font-size: 14px;
        .item-title {
          height: 50px;
          line-height: 50px;
          padding-left: 20px;
          display: flex;
          border-bottom: 1px solid #E6E8EE;
        .title-date{
            width: 204px; 
            .day{
               color: #000000 ;
               font-size: 16px;
               font-weight: bold;
            }  
            .title-time{
                color: #C0C4CC;
                font-size: 14px;
            }
        }
        .title-income{
            width: 230px;
            color: #E1251B;
            font-size: 16px;
        }
        .title-expenses{
            color: #55B148;
            font-size: 16px;
        }
        }
        .item-content{
            background-color: #f5f5f5;
            border-bottom: 1px solid #E6E8EE;
            padding-left: 90px;
            height: 45px;
            display: flex;
            align-items: center;
            .item-img{
                img{
                    width: 20px;
                    height: 20px;
                    vertical-align: middle;
                }
                line-height: 45px;
            }
           .item-name{
               width: 220px;
               font-size: 14px;
               line-height: 45px;
               display: inline-block;
               margin-left: 8px;
           }
           .item-type{
               width: 20px;
               margin-right: 10px;
               line-height: 45px;
               color: #E1251B;
           }
           .item-typezhi{
               width: 20px;
               margin-right: 10px;
               line-height: 45px;
               color: #55B148;
           }  
           .item-Amount{
               width: 297px;
               text-align: left;
               display: inline-block;
               line-height: 45px;
           }
           .item-remark{
               width: 184px;
               font-size: 12px;
               display: inline-block;
               margin-right: 70px;
               color: #666666;
               word-wrap:break-word 
           }
           .item-icon{
               width: 14px;
               cursor: pointer;
               img{
                 width: 14px;
                 height: 14px;
               }
           }
           .mar-20{
             margin-right: 20px;
           }
        }
      }
    }
  }
}
// 取消纵向滚动条
::-webkit-scrollbar {
  display: none;
}
</style>
<!--
 appendbody的弹窗只能全局改样式
-->
<style lang="scss">
.el-dialog.editindividualrecord {
  .el-dialog__header {
    padding: 15px 20px;
  }

  .el-dialog__body {
    border-top: 1px solid #E4E7ED;
  }

  .el-button--default {
    color: #969696 !important;
    background: #fff;
    border-color: #E4E7ED !important;

    // &:hover {
    //   color: #B79255 !important;
    //   background: #fff;
    //   border-color: #B79255 !important;
    // }
  }

  .el-button--primary {
    background: #B79255 !important;
    border-color: #B79255 !important;
      &:hover{
      color: #fff;
      border-color: #b79255;
      background: #b79255;
  }
  }
}
</style>